import { DatePipe, NgIf } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Gallery, GalleryComponent, GalleryRef } from "ng-gallery";
import { GallerizeDirective } from "ng-gallery/lightbox";
import { Subscription, firstValueFrom } from "rxjs";
import { ConfigService } from "src/app/servicios/config/config.service";
import { SliderGalleryComponent } from "../slider-gallery/slider-gallery.component";
import { AlbumsService } from "@src/app/servicios/albums/albums.service";

@Component({
  selector: "app-detalle-album",
  templateUrl: "./detalle-album.component.html",
  styleUrls: ["./detalle-album.component.css", "../../../../node_modules/keen-slider/keen-slider.min.css"],
  imports: [GalleryComponent, GallerizeDirective, DatePipe, SliderGalleryComponent, NgIf],
  providers: [AlbumsService],
})
export class DetalleAlbumComponent implements OnInit, OnDestroy {
  constantesGlobales: any;
  albums: any;

  galleryId = "gallery";
  galleryMain: GalleryRef;

  galleryIdRel = "galleryRel";
  galleryRel: GalleryRef;

  is_video: boolean;
  albumsRel: any;
  imagesSlider;
  imagenes_relacionadas: any[] = [];
  rSub: Subscription;

  constructor(
    private albumsService: AlbumsService,
    private configService: ConfigService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private gallery: Gallery,
  ) {
    this.galleryMain = this.gallery.ref(this.galleryId);
    this.galleryRel = this.gallery.ref(this.galleryIdRel);

    this.constantesGlobales = this.configService.getConstantesGlobales();
  }

  ngOnInit(): void {
    const idAmbito = this.constantesGlobales.idAmbito;

    this.imagenes_relacionadas = [];
    // const galleryRef: GalleryRef = this.gallery.ref(this.galleryId);

    this.imagesSlider = {
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,

      nextArrow: '<svg class="arrows svg-icon__arrow--right" viewBox="0 0 7 12" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path  fill-rule="evenodd" d="M6.893 5.967c0-.268-.107-.524-.295-.713L1.724.37C1.33-.024.692-.024.3.37c-.394.394-.394 1.033 0 1.427l4.162 4.17L.3 10.137c-.394.394-.394 1.033 0 1.427.392.394 1.03.394 1.424 0L6.598 6.68c.188-.19.295-.445.295-.713z"/></svg>',
      prevArrow: '<svg class="arrows svg-icon__arrow--left" viewBox="0 0 7 12" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path  fill-rule="evenodd" d="M.107 6.033c0 .268.107.524.295.713l4.874 4.884c.394.394 1.032.394 1.424 0 .394-.394.394-1.033 0-1.427l-4.162-4.17L6.7 1.863c.394-.394.394-1.033 0-1.427-.392-.394-1.03-.394-1.424 0L.402 5.32c-.188.19-.295.445-.295.713z"/></svg>',
    };

    this.rSub = this.activatedRoute.params.subscribe((parms: any) => {
      this.is_video = this.router.url.split("/")[1] == "videos" ? true : false;
      //console.log('this.is_video', this.is_video, this.router.url.split("/")[1]);

      if (parms.id) {
        const album = this.albumsService.getAlbums(idAmbito, parms.id, null, this.is_video);
        if (album) {
          firstValueFrom(album).then((result) => {
            if (!result) return;
            this.galleryMain.reset();
            if (!result[0].data) {
              this.router.navigateByUrl("/404");
              return;
            }
            this.albums = result;

            const elements = this.albums[0]?.data;

            if (elements && Array.isArray(elements)) {
              elements.forEach((element) => {
                this.setGallery(this.galleryMain, element?.data, element.tipo_data);
              });
            }
          });
        }

        const albums = this.albumsService.getAlbums(idAmbito, null, 16, this.is_video);
        if (albums) {
          firstValueFrom(albums).then((result) => {
            if (!result) return;
            if (Object.keys(result).length > 0) {
              this.albumsRel = result;
            } else {
              this.albumsRel = "";
            }

            if (this.albumsRel && Array.isArray(this.albumsRel)) {
              this.albumsRel.forEach((e) => {
                const elements = e?.data;
                elements.forEach((element) => {
                  this.imagenes_relacionadas.push(this.getThumb(element?.data, element.tipo_data, e.id));
                });
              });
            }
          });
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.rSub.unsubscribe();
  }

  formatDate(obj) {
    if (obj == null) {
      return null;
    }
    return obj.toString().replace(/\s/g, "T");
  }

  setGallery(gallery, data, tipo) {
    switch (tipo) {
      case "1":
        gallery.addImage({
          src: data,
          thumb: data,
        });
        break;

      case "2":
        gallery.addYoutube({
          src: data,
        });
        break;

      case "3":
        gallery.addIframe({
          src: data,
        });
        break;
    }
  }

  getThumb(data, tipo, id) {
    let aux;
    switch (tipo) {
      case "1":
        aux = { data: data, id: id };
        break;
      case "2":
        aux = { data: "https://img.youtube.com/vi/" + data + "/0.jpg", id: id };
        break;

      case "3":
        aux = { data: " https://vumbnail.com/" + data + ".jpg", id: id };
        break;
    }
    return aux;
  }
}
